'use strict';

// Initialize required libraries
var dialog = require('./dialog');
var ajax = require('./ajax');
var util = require('./util');
var progress = require('./progress');
var tealium = require('../../../int_tealium/cartridge/js/tealium/tealium');
var page = require('./page');
// This class is used to render the International Shipping Modal display.  
var InternationalShipping = {
    //init the modal 
    InvalidItemRemoved: false, //flag indicate the invalid item is removed
    init: function () {

        //bind click to get order form
        this.bindClickToGetOrderForm();

        //on page load check if page came back with errors and adjust form 
        this.hidePostalCodeField();

        this.InvalidItemRemoved = false;

    },

    getCountrySelectionModal : function(refreshPageAfterRemovingItems){        
        var that = this;
        //show the international shipping modal with the success ajax call to iParcel
        var url = util.ajaxUrl(util.appendParamToURL(Urls.countrySelectionModal, 'InvalidItemRemoved', that.InvalidItemRemoved));
        
        if(!refreshPageAfterRemovingItems){
            that.InvalidItemRemoved = false;            
        }


        dialog.open({
            url: url,
            closeOnEscape: true,
            options : {
                dialogClass: 'intl-shipping',
                width: 820,
                open: function(data) {
                    //globale TODO - change how we recognze that url returns view that don't have items to be removed
                    if(data.target.innerHTML.indexOf("empty") >= 0){
                        dialog.close();   
                        if(SitePreferences.GLOBALE_ENABLED && SitePreferences.GLOBALE_IS_PHASE2){   
                            page.redirect(Urls.globalECheckout);
                        }else{
                            gle('ShippingSwitcher', 'show');                            
                        }
                    }
        
                    $('.intl-shipping .ui-dialog-titlebar-close, .ui-widget-overlay, .intl-shipping .cancel, .ui-dialog-titlebar-close').click(function(e){                        
                        e.preventDefault();
                        
                        //close modal
                        dialog.close();
                        
                        //refresh cart page if invalid item is remove from the previous modal
                        if (that.InvalidItemRemoved) {
                            page.refresh();
                        }
                    });

                    $('.remove-items').click(function(e){
                        e.preventDefault();                    
                        that.removeIntItems(e);
                    });

                    $('.go-back-to-cart').click(function(e){
                        e.preventDefault();                    
                        page.redirect('/cart');  
                    });

                }
            }
        });
    },

    formSubmit: function (e){        
        e.preventDefault();
        var country_name = $("#country_code option:selected" ).text();
        var country_name_val = $("#country_code option:selected" ).val();        
        if(country_name_val === 'select'){
            //display error message
            $('.international_error_msg').css('display', 'inline-block');
            $('.international-shipping-modal select').addClass('bkg-error');
        }else{
            //prepare object for tealium event
            var obj = {
                event_name:"International_Shipping",
                international_shipping_country : country_name
            };
            //trigger tealium event           
            tealium.triggerEvent(obj);

            $("#international-modal-form").submit();            
        }
    },

    removeIntItems: function (e){
        e.preventDefault();
        var $form = $(".intExclusion-shipping");
        //show the international shipping modal with the success ajax call to iParcel
        var url = util.ajaxUrl(util.appendParamToURL($form.attr('action'), 'type', 'int'));
        var that = this;
        ajax.load({
            url: url,
            method: "POST",
            data: $form.serialize(),
            callback: function (data) {
                var responseObj = JSON.parse(data);
                if(responseObj.success === true){
                    if(responseObj.isBasketEmpty){
                        page.redirect('/cart');                        
                    }else{
                        that.InvalidItemRemoved = true;  
                        dialog.close();       
                        if(SitePreferences.GLOBALE_ENABLED && SitePreferences.GLOBALE_IS_PHASE2){
                            page.redirect(Urls.globalECheckout);
                        }else{
                            return gle('ShippingSwitcher', 'show');
                        }                        
                    }
                }
            }
        })
    },

    bindClickToGetOrderForm: function(){     
        $('body').on('change', '[name$="input-radio-name"]', function (e) {     
            var form = $(this).closest('form');
            var selectedVal;
            // reset any validation errors, if any
            form.validate().resetForm();
            if($('[id$="_domestic"]').prop("checked")){
                selectedVal = "domestic";
                form.find('.postalCode').addClass('required').show();
                form.find('[id$="_postalCode"]').prop('required',true).show();
                form.find('[id$="_orderNumber"]').removeAttr('required').show();
                form.find('[id$="_orderEmail"]').removeAttr('required').show();
                $('.internationaLookupButton').hide();
                $('.orderLookupNarvar').show();
                $('.orderLookupDefaultForm.zq, .orderLookupDefaultForm.cp, .orderLookupDefaultForm.da, .orderLookupDefaultForm.av').show();
                if(SitePreferences.NARVAR_RETURNS_ENABLED){
                    $(".orderLookupDefaultForm").hide(); 
                    $(".orderLookupDefaultForm.zq, .orderLookupDefaultForm.cp, .orderLookupDefaultForm.da, .orderLookupDefaultForm.av").show();                     
                    $(".orderLookupNarvar").show();
                    $(".orderHeaderDefault").hide();
                    $(".orderHeader").show();
                }             
            }else if($('[id$="_international"]').prop("checked")){
                selectedVal = "international";                
                form.find('.postalCode').removeClass('required').hide();
                form.find('[id$="_postalCode"]').removeAttr('required').hide();
                form.find('[id$="_orderNumber"]').removeAttr('required').hide();
                form.find('[id$="_orderEmail"]').removeAttr('required').hide();
                $('.internationaLookupButton').removeClass("hide");
                $('.internationaLookupButton').show();
                $('.orderLookupNarvar').hide();
                if(SitePreferences.NARVAR_RETURNS_ENABLED){
                    $(".orderLookupDefaultForm").hide();
                    $(".orderHeaderDefault").show();
                    $(".orderHeader").hide();
                }
            }
            form.find('input[name="orderType"]').val(selectedVal);
        });
    },

    hidePostalCodeField : function(){
        var isInternational = ($('[name$="isInternationalOrder"]').val() === 'true');        
        if(isInternational){
            var form = $('[id$="_ordertrack"]');
            form.find('.postalCode').removeClass('required').hide();
            form.find('[id$="_postalCode"]').removeAttr('required').hide();
            $('[id$="_international"]').prop("checked", true);
        }
    },

    selectCountryDropdownEvents : function(){        
        $("#country_code" ).change(function() {            
            var country_name_val = $("#country_code option:selected" ).val();  
            if(country_name_val !== 'select'){                
                //display error message
                $('.international_error_msg').hide();
                $('.international-shipping-modal select').removeClass('bkg-error');
            }
        });
    },
    internationalProductExculsionModalEvents : function(){

        var $container = $('.intl-exclusion-modal');

        if(!$container.length || $container.hasClass('hide')) return;

        util.trapFocus($container, function(){
            $container.find('button[aria-label="close"]').trigger('click');
        },false);
        
        $container.find('button[aria-label="close"],.dialog-overlay').on('click',function(){
            $container.addClass('hide');
        });
    },
    directCheckoutInternationalFunc : function(){
        var invalidItemRemoved = false;
        var url = util.ajaxUrl(util.appendParamToURL(Urls.countrySelectionModal, 'InvalidItemRemoved', invalidItemRemoved));
        ajax.load({
            url: url,
            callback: function (response) {
                if(response.indexOf("empty") >= 0){
                    page.redirect(Urls.globalECheckout);
                }else{
                    localStorage.setItem('hasInvalidIntlItems',true);
                    page.redirect('/cart');
                }
            }
        });
    }
}

module.exports = InternationalShipping;